import { useState, useEffect } from "react";
import { fetchTender } from "../../api/api";

export const useTenderFiles = ({ tenderId, step, setLoading }) => {
    const [files, setFiles] = useState([]);

    useEffect(() => {
        const fetchFiles = async () => {
            try {
                setLoading(true);
                const tender = await fetchTender(tenderId);
                setFiles(tender.file_metadata || []);
            } catch (error) {
                console.error(`An error occurred fetching the files for tender ${tenderId}`);
                setFiles([]);
            } finally {
                setLoading(false);
            }
        };

        if (step === 2 && files.length === 0) {
            fetchFiles();
        }
    }, [step, tenderId]);

    return { files, setFiles };
};